import React, { useState } from "react";
import { formatFullName, pluralizeText } from "../../../../lib/utils";
import { Button, Collapse } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

function CheckInOtherAttendeeDetails(props) {
  const { otherAttendees } = props;

  const [expandOtherAttendees, setExpandOtherAttendees] = useState(false);

  return (
    <div className="checkin-shliach-chap-details">
      <div className="student-checkin-details">
        <Button
          onClick={() => setExpandOtherAttendees(!expandOtherAttendees)}
          disableRipple
          className="flex"
          size="large"
          variant="text"
        >
          {otherAttendees.length}{" "}
          {pluralizeText("other attendee", otherAttendees.length)}
          {expandOtherAttendees ? (
            <ExpandLess fontSize="large" />
          ) : (
            <ExpandMore fontSize="large" />
          )}
        </Button>

        <Collapse
          in={expandOtherAttendees}
          className="expanded-list-wrapper accent-text"
        >
          {otherAttendees.map((a) => {
            return (
              <p key={a.id}>
                {formatFullName(a.firstName, a.lastName)}
                {a.assignedVenueID ? (
                  <span className="italic-text block">
                    {a.assignedVenueName}
                  </span>
                ) : (
                  ""
                )}
              </p>
            );
          })}
        </Collapse>
      </div>
    </div>
  );
}

export default React.memo(CheckInOtherAttendeeDetails);
